module.exports = __webpack_public_path__ + "static/media/screen5.998ddb29.png";